<div class="card recent-sales overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        {{ viewDate | calendarDate : view + 'ViewTitle' : 'en' }}
      </h5>
      <div class="d-flex justify-content-end gap-2">
        <div class="btn btn-outline-dark" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay($event)">
          <i class="bi bi-arrow-left-short"></i>
        </div>
        <div class="btn btn-outline-dark" mwlCalendarToday [(viewDate)]="viewDate">Today</div>
        <div class="btn btn-outline-dark" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay($event)">
          <i class="bi bi-arrow-right-short"></i>
        </div>

        <div class="filter">
          <a class="btn btn-light h-100" href="#" data-bs-toggle="dropdown">
            <i class="bi bi-three-dots-vertical fs-5"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
            <li>
              <button class="dropdown-item" (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">Month</button>
            </li>
            <li>
              <button class="dropdown-item" (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">Week</button>
            </li>
            <li>
              <button class="dropdown-item" (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">Day</button>
            </li>
          </ul>
        </div>
      </div>

      <!--      
            <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
        >
          Month
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
        >
          Week
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
        >
          Day
        </div>
      </div>
            
            -->
    </div>
  </div>

  <div class="card-body pt-3">
    <div class="calender-view-wrapper">
      <div [ngSwitch]="view">
        <mwl-calendar-month-view
          *ngSwitchCase="CalendarView.Month"
          [viewDate]="viewDate"
          [events]="CalenderEvents"
          [refresh]="refresh"
          [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-month-view>
        <mwl-calendar-week-view
          *ngSwitchCase="CalendarView.Week"
          [viewDate]="viewDate"
          [events]="CalenderEvents"
          [refresh]="refresh"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-week-view>
        <mwl-calendar-day-view
          *ngSwitchCase="CalendarView.Day"
          [viewDate]="viewDate"
          [events]="CalenderEvents"
          [refresh]="refresh"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-day-view>
      </div>
    </div>
  </div>
</div>
